import { render, staticRenderFns } from "./TeamSummaryChat.vue?vue&type=template&id=cdbde9de&scoped=true"
import script from "./TeamSummaryChat.vue?vue&type=script&lang=js"
export * from "./TeamSummaryChat.vue?vue&type=script&lang=js"
import style0 from "./TeamSummaryChat.vue?vue&type=style&index=0&id=cdbde9de&prod&lang=scss"
import style1 from "./TeamSummaryChat.vue?vue&type=style&index=1&id=cdbde9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbde9de",
  null
  
)

export default component.exports